import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/scss/app.scss"
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.min.css'
import 'vue3-tour/dist/vue3-tour.css'
import 'vue-rate/dist/vue-rate.css'
import 'sweetalert2/dist/sweetalert2.min.css';
import "vue-multiselect/dist/vue-multiselect.css"
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css'; 
import 'vue3-form-wizard/dist/style.css'

import VueFeather from 'vue-feather';
import vueChartist from "vue-chartist"
import Breadcrumbs from './components/BreadCrumbs.vue'
import VueApexCharts from "vue3-apexcharts";
import VueNumber from "vue-number-animation";
import Datepicker from '@vuepic/vue-datepicker';
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import Vue3Tour from 'vue3-tour'
import rate from 'vue-rate'
import VueSweetalert2 from 'vue-sweetalert2';
import Toaster from "@meforma/vue-toaster";
import Multiselect from 'vue-multiselect'
import SimpleTypeahead from 'vue3-simple-typeahead';
import Vue3FormWizard from 'vue3-form-wizard'
import Lightbox from 'vue-easy-lightbox'
import {VueMasonryPlugin} from 'vue-masonry';
import { quillEditor } from "vue3-quill";

import { createI18n } from 'vue-i18n'
import English from "./locales/en.json"
import Spanish from "./locales/es.json"
import French from "./locales/fr.json"
import Portuguese from "./locales/pt.json"

if (!window.__authFetchPatched__) {
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const response = await nativeFetch(input, init);
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isLoginRequest = url.includes('/api/Auth/Login');

    if (response.status === 401 && !isLoginRequest) {
      localStorage.removeItem('token');
      store.dispatch('auth/clearPermissions');

      if (router.currentRoute.value.path !== '/auth/login') {
        router.replace('/auth/login').catch(() => {});
      }
    }

    return response;
  };
  window.__authFetchPatched__ = true;
}

const i18n = createI18n({ legacy: false, // you must specify 'legacy: false' option
  locale: 'English',
  messages: {
   English: English,
    Spanish: Spanish,
    French: French,   
   Portuguese: Portuguese,
    }
  })

createApp(App)
.use(store)
.use(router)
.use(vueChartist)
.use(VueApexCharts)
.use(VueNumber)
.use(PerfectScrollbar)
.use(Vue3Tour)
.use(VueSweetalert2)
.use(rate)
.use(i18n)
.use(Toaster)
.use(Lightbox)
.use(VueMasonryPlugin)
.use(Vue3FormWizard)
.use(SimpleTypeahead)
.use(quillEditor)
.component(VueFeather.name, VueFeather)
.component('Breadcrumbs', Breadcrumbs)
.component('Datepicker', Datepicker)
.component('multiselect', Multiselect)
.mount('#app')
